import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PartiesPage from './pages/PartiesPage';
import PartyDetailPage from './pages/PartyDetailPage';
import MemberDetailPage from './pages/MemberDetailPage';
import LegislationPage from './pages/LegislationPage';
import BillDetailPage from './pages/BillDetailPage';
import CommitteesPage from './pages/CommitteesPage';
import CommitteeDetailPage from './pages/CommitteeDetailPage';
import GovernmentPage from './pages/GovernmentPage';
import QueryDetailPage from './pages/QueryDetailPage';
import QueriesPage from './pages/QueriesPage';
import LobbyistDetailPage from './pages/LobbyistDetailPage';
import SchedulePage from './pages/SchedulePage';
import MinistryDetailPage from './pages/MinistryDetailPage';
import SearchPage from './pages/SearchPage';
import FundingExplainerPage from './pages/FundingExplainerPage';

// Development-only component gallery (/dev/ui); never routed in production builds
const UiGallery = process.env.NODE_ENV === 'development' ? React.lazy(() => import('./dev/UiGallery')) : null;

// Remounts the page whenever the path changes, so moving between two items on the
// same route (e.g. member → member) starts from fresh state instead of carrying it over.
const Keyed = ({ component: Page }: { component: React.ComponentType }) => {
  const location = useLocation();
  return <Page key={location.pathname} />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/parties" />} />
        <Route path="/parties" element={<PartiesPage />} />
        {/* A static path, so it wins over :partyId */}
        <Route path="/parties/funding" element={<FundingExplainerPage />} />
        <Route path="/parties/:partyId" element={<Keyed component={PartyDetailPage} />} />
        <Route path="/members/:memberId" element={<Keyed component={MemberDetailPage} />} />
        <Route path="/legislation" element={<LegislationPage />} />
        <Route path="/legislation/:billId" element={<Keyed component={BillDetailPage} />} />
        <Route path="/committees" element={<CommitteesPage />} />
        <Route path="/committees/:committeeId" element={<Keyed component={CommitteeDetailPage} />} />
        <Route path="/government" element={<GovernmentPage />} />
        <Route path="/queries" element={<QueriesPage />} />
        <Route path="/queries/:queryId" element={<Keyed component={QueryDetailPage} />} />
        {/* The old lobbyist list was replaced by the lobbyists tab on /committees */}
        <Route path="/lobbyists" element={<Navigate to="/committees?tab=lobbyists" replace />} />
        <Route path="/lobbyists/:lobbyistId" element={<Keyed component={LobbyistDetailPage} />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/government/ministries/:ministryId" element={<Keyed component={MinistryDetailPage} />} />
        <Route path="/search" element={<SearchPage />} />
        {UiGallery && <Route path="/dev/ui" element={<React.Suspense fallback={null}><UiGallery /></React.Suspense>} />}
      </Routes>
    </BrowserRouter>
  );
}

export default App;